import { send } from '../../../../../src/network/network';
import { type ProductDetail } from '../../../../../src/types/ProductDetail';
import {
  type OrderDateParam,
  setOrderDateParam,
} from '../../../../../src/utils/orderDateParam';

export type GetProductParams = {
  orderDate?: OrderDateParam;
  origin?: number;
  productId: number;
};

export function getProductPath({ productId }: GetProductParams) {
  return `/api/v2/products/${productId}/`;
}

export async function getApiV2ProductsId(params: GetProductParams) {
  const queryParams = new URLSearchParams();

  setOrderDateParam(queryParams, params.orderDate);

  if (params.origin !== undefined) {
    queryParams.append('origin', params.origin.toString());
  }

  return await send<ProductDetail>({
    path: getProductPath(params),
    method: 'GET',
    query: queryParams,
  });
}
